import { render, staticRenderFns } from "./moneypk.vue?vue&type=template&id=30605f17&scoped=true&"
import script from "./moneypk.vue?vue&type=script&lang=js&"
export * from "./moneypk.vue?vue&type=script&lang=js&"
import style0 from "./moneypk.vue?vue&type=style&index=0&id=30605f17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30605f17",
  null
  
)

export default component.exports